export default {
  computed: {
    payedItems() {
      return [
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.payed'),
          value: 1,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.not_payed'),
          value: 0,
        },
      ];
    },
  },
};
